import React from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import Card from '../Card/Card'

import * as Styled from '../styles'
import { useAppSelector } from '../../hooks'

// TODO--låg-prio slå ihop komponent med SizePanel!
const ASSEMBLY_ID = 'assembly'

const RoofCladdingPanel: React.FC = () => {
  const configurator = useConfiguratorContext()

  const {
    props: { roofCladding },
  } = useAppSelector((state) => state.configResult) as any
  const { assetBaseUrl, content } = useAppSelector((state) => state.init)

  return (
    <Styled.Panel>
      <Styled.Grid $responsive>
        {roofCladding.options.map((option: any) => (
          <Card
            key={option.value}
            type="lightweight"
            height={100}
            isSelected={option.value === roofCladding.value}
            onClick={() => {
              configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
                roofCladding: option.value,
              })
            }}
            dangerouslySetInfo={content?.props?.roofCladding?.options?.[option.value]?.description}
            mediaAlt={content?.props?.roofCladding?.options?.[option.value]?.title}
            mediaImage={`${assetBaseUrl}${content?.props?.roofCladding?.options?.[option.value]?.image}`}
            title={content?.props?.roofCladding?.options?.[option.value]?.title}
            titleLong={content?.props?.roofCladding?.options?.[option.value]?.description}
          />
        ))}
      </Styled.Grid>
    </Styled.Panel>
  )
}

export default RoofCladdingPanel
